/**
 * GTM Loader Utility
 * Conditionally loads Google Tag Manager based on user consent
 */

let gtmLoaded = false;

export const loadGTM = (): void => {
  if (gtmLoaded || typeof window === 'undefined') {
    return;
  }

  // Use requestIdleCallback to load GTM when browser is idle
  const loadScript = () => {
    gtmLoaded = true;

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Create and inject GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-K93PPCH2';
    
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    console.log('GTM loaded via consent-based loading');
  };

  // Defer loading until browser is idle - longer timeout on mobile
  const isMobile = window.innerWidth < 1024;
  const timeout = isMobile ? 5000 : 3000;
  
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadScript, { timeout });
  } else {
    setTimeout(loadScript, timeout);
  }
};

export const isGTMLoaded = (): boolean => {
  return gtmLoaded;
};

// Extend Window interface for TypeScript
declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}
